// https://www.npmjs.com/package/react-slideshow-image
import React from 'react';
import { Slide } from 'react-slideshow-image';
import './SlidesStyles.css'
import 'react-slideshow-image/dist/styles.css'
// import EachSlide from './EachSlide1Page';
import EachSlide1Page from './EachSlide1Page';

const properties = {
  duration: 7000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: true
}

const Slideshow = (type) => {
  const numbersArray = Array.from({ length: 11 }, (_, index) => index);

    return (
        <div className='slideshow-supercontainer'>
        <div className='slideshow-container'>

      <h3 className='projType'>Single-Feature-Apps</h3>
      <div>
      <Slide {...properties}>
      {numbersArray.map((el)=>(
        <EachSlide1Page projNo={el}/>
      ))}
      </Slide>
    

      </div>
      </div>
      </div>
    )
}

export default Slideshow